import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import { Button } from "@heroui/react";
import { Send } from "lucide-react";
import type { InvoiceEmailRecipient } from "./invoice-actions";

export function SendInvoiceEmailButton({
  recipient,
  isDisabled,
  isLoading,
  onSend,
}: {
  recipient: Exclude<InvoiceEmailRecipient, { status: "no-recipient" }>;
  isDisabled: boolean;
  isLoading: boolean;
  onSend: (recipientEmail: string) => Promise<unknown>;
}) {
  return (
    <div className="flex flex-col gap-1">
      <Button
        isDisabled={isDisabled || recipient.status === "missing-email"}
        isLoading={isLoading}
        className="h-12"
        color="primary"
        data-identifier="send-invoice-email"
        startContent={<Send size={16} />}
        onPress={async () => {
          if (recipient.status !== "ready") return;

          await onSend(recipient.email);
        }}
      >
        <Trans>Pošlji po e-pošti</Trans>
      </Button>
      {recipient.status === "missing-email" && (
        <p
          className="text-orange-600 text-sm"
          data-identifier="send-invoice-email-missing"
        >
          {recipient.recipient === "company"
            ? t`Podjetje nima vnesenega e-poštnega naslova, zato dokumenta ni mogoče poslati po e-pošti.`
            : t`Stranka nima vnesenega e-poštnega naslova, zato dokumenta ni mogoče poslati po e-pošti.`}
        </p>
      )}
    </div>
  );
}
